import { render, staticRenderFns } from "./play-circle.vue?vue&type=template&id=2527ca0b"
import script from "./play-circle.vue?vue&type=script&lang=js"
export * from "./play-circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports